import { PageHero } from "@/components/site/Bits";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useI18n } from "@/i18n/I18nContext";

export default function Faq() {
  const { t } = useI18n();
  const faqs = t("faq.items");
  return (
    <div>
      <PageHero eyebrow={t("faq.eyebrow")} title={t("faq.title")} subtitle={t("faq.subtitle")} />
      <section className="max-w-3xl mx-auto px-5 sm:px-8 pb-24" data-testid="faq-list">
        <Accordion type="single" collapsible className="space-y-3">
          {(Array.isArray(faqs) ? faqs : []).map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="glass rounded-2xl px-5 border-none" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left text-white font-display hover:no-underline">{f.q}</AccordionTrigger>
              <AccordionContent className="text-zinc-400">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </div>
  );
}
